import React from 'react';
import { Button, Space } from 'antd';
import { useTranslation } from 'react-i18next';
import { ExpenseActionsProps } from '../types';

/**
 * ExpenseActions Component
 * 
 * Renders the action buttons for the expense form:
 * - Save/Create button (for draft and new expenses)
 * - Approve and Submit button (for draft expenses)
 * - Handles button states and visibility based on expense status
 */
export const ExpenseActions: React.FC<ExpenseActionsProps> = ({
  status,
  formChanged,
  submitting,
  onSave,
  onApprove,
}) => {
  const { t } = useTranslation();

  return (
    <div style={{ textAlign: 'center' }}>
      <Space>
        {status !== 'sent' && (
          <Button
            type="primary"
            onClick={onSave}
            disabled={!formChanged || status === 'sent' || submitting}
            loading={submitting}
          >
            {status === '' ? t('Create expense') : t('Save')}
          </Button>
        )}
        {status === 'draft' && (
          <Button
            type="primary"
            onClick={onApprove}
            disabled={submitting}
          >
            {t('Approve and Submit')}
          </Button>
        )}
      </Space>
    </div>
  );
};